var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.7184 14.8461C37.4603 24.6312 30.9413 33.9775 21.1538 35.7193C19.8164 35.9575 18.488 36.0415 17.1848 35.9827C15.5473 35.911 13.9514 35.6141 12.4338 35.1191C11.0793 34.6779 9.78671 34.0769 8.58306 33.3373C8.21527 33.1114 7.85483 32.8725 7.50417 32.6197C5.9629 31.5139 4.59615 30.1659 3.46425 28.6197C3.24325 28.318 3.03041 28.0081 2.82898 27.6917C1.59189 25.7581 0.707092 23.5539 0.279777 21.1547C0.240633 20.9354 0.206377 20.7152 0.17702 20.4942C-1.1669 10.9522 5.27871 1.98428 14.8444 0.281543C17.1987 -0.137617 19.5269 -0.078096 21.7295 0.389178C22.1552 0.479697 22.576 0.584895 22.9919 0.705587C24.8072 1.23076 26.5197 2.03728 28.0683 3.08437C28.41 3.31515 28.7427 3.55652 29.0681 3.81014C30.2245 4.71125 31.2715 5.75347 32.1824 6.91716C33.1211 8.11674 33.9145 9.44599 34.5318 10.8821C34.982 11.9308 35.3384 13.0366 35.5871 14.1913C35.6368 14.4082 35.6801 14.6268 35.7184 14.8461Z",
    fill: "url(#paint0_linear_1_7006)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.5325 10.879L17.1846 35.9805C15.5471 35.9087 13.9512 35.6118 12.4336 35.1168L32.1831 6.91406C33.1225 8.11364 33.916 9.44289 34.5325 10.879Z",
    fill: "#F2F0F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.9925 0.705081L3.46486 28.62C3.24386 28.3183 3.03102 28.0084 2.82959 27.692L21.7301 0.388672C22.1558 0.479191 22.5766 0.584389 22.9925 0.705081Z",
    fill: "#F2F0F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.0691 3.80896L8.58328 33.3377C8.2155 33.1118 7.85505 32.8729 7.50439 32.6201L28.0685 3.08398C28.411 3.31395 28.7437 3.55534 29.0691 3.80896Z",
    fill: "#F2F0F3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.1622 15.4786C32.2014 15.6955 32.234 15.914 32.2642 16.131C33.2591 23.7011 28.1133 30.8105 20.5212 32.1618C12.929 33.513 5.64588 28.6161 3.96761 21.1682C3.92112 20.9537 3.87709 20.7376 3.83795 20.5207C2.44754 12.7116 7.66991 5.22789 15.479 3.83748C23.2881 2.44708 30.7718 7.66866 32.1622 15.4786Z",
    fill: "url(#paint1_linear_1_7006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.2641 16.1326C33.259 23.7027 28.1132 30.8121 20.5211 32.1634C20.3514 32.1936 20.1826 32.2197 20.0138 32.2433C18.3095 32.4855 16.6279 32.4162 15.0255 32.0753C13.4239 31.7345 11.9046 31.1245 10.5273 30.2845C10.1774 30.0717 9.83737 29.845 9.50465 29.602C7.99927 28.4978 6.70346 27.1058 5.71591 25.4838C5.47778 25.0964 5.25679 24.6927 5.05699 24.2801C4.58156 23.3064 4.21459 22.265 3.96668 21.1698C2.97179 13.5997 8.11752 6.48863 15.7097 5.13737C16.6703 4.96612 17.6261 4.89597 18.568 4.91799C19.0467 4.92859 19.5237 4.96368 19.9951 5.02239C21.9188 5.26133 23.7512 5.8868 25.3936 6.83195C25.7475 7.03582 26.0949 7.25518 26.4325 7.49085C27.7422 8.3993 28.9026 9.52387 29.8535 10.8246C30.7807 12.0927 31.5081 13.5246 31.986 15.0847C32.092 15.4272 32.185 15.7778 32.2641 16.1326Z",
    fill: "url(#paint2_linear_1_7006)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.9854 15.0851L20.0132 32.243C18.3089 32.4852 16.6273 32.4158 15.0249 32.075L29.8529 10.8242C30.7801 12.0923 31.5075 13.5243 31.9854 15.0851Z",
    fill: "url(#paint3_linear_1_7006)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.9947 5.02121L5.71555 25.4826C5.47743 25.0952 5.25643 24.6916 5.05664 24.2789L18.5676 4.91602C19.0463 4.92743 19.5234 4.9625 19.9947 5.02121Z",
    fill: "url(#paint4_linear_1_7006)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.4324 7.49175L10.528 30.2854C10.1781 30.0726 9.83809 29.8459 9.50537 29.6029L25.3943 6.83203C25.7474 7.03672 26.0948 7.25608 26.4324 7.49175Z",
    fill: "url(#paint5_linear_1_7006)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.2369 13.1093C13.8532 11.2393 15.931 10.2461 18.2397 10.2461C21.3108 10.2461 23.7344 12.1853 23.7344 15.3021C23.7344 17.9573 22.4875 18.8813 20.0403 20.4739C18.932 21.1899 17.1078 22.6439 16.5769 23.5679H20.6405V21.7208H24.5189V26.6382H12.0518V23.2906C13.3215 21.2128 13.9453 20.5432 15.423 19.3657C17.0621 17.9108 19.5094 16.9412 19.5094 15.51C19.5094 14.3325 18.6319 13.9859 17.5702 13.9859C16.3233 13.9859 15.423 15.002 14.7306 15.7408L12.2369 13.1093Z",
    fill: "url(#paint6_linear_1_7006)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.2369 12.2264C13.8532 10.3565 15.931 9.36328 18.2397 9.36328C21.3108 9.36328 23.7344 11.3025 23.7344 14.4193C23.7344 17.0745 22.4875 17.9985 20.0403 19.5911C18.932 20.3071 17.1078 21.7611 16.5769 22.6851H20.6405V20.838H24.5189V25.7554H12.0518V22.4078C13.3215 20.3299 13.9453 19.6604 15.423 18.4829C17.0621 17.0281 19.5094 16.0584 19.5094 14.6272C19.5094 13.4497 18.6319 13.1031 17.5702 13.1031C16.3233 13.1031 15.423 14.1192 14.7306 14.858L12.2369 12.2264Z",
    fill: "url(#paint7_linear_1_7006)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7006",
    x1: 18.0005,
    y1: 10.2917,
    x2: 18.0005,
    y2: 47.1738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#E9E9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7006",
    x1: 3.61385,
    y1: 17.9994,
    x2: 32.3871,
    y2: 17.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_7006",
    x1: 19.3649,
    y1: 3.52196,
    x2: 17.5847,
    y2: 25.0818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#E9E9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_7006",
    x1: 23.5052,
    y1: 19.3093,
    x2: 23.5052,
    y2: 67.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#E9E9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_7006",
    x1: 12.526,
    y1: 19.3085,
    x2: 12.526,
    y2: 67.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#E9E9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_7006",
    x1: 17.9687,
    y1: 19.3105,
    x2: 17.9687,
    y2: 67.3752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#E9E9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_7006",
    x1: 18.6433,
    y1: 13.6565,
    x2: 18.333,
    y2: 20.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_7006",
    x1: 18.2864,
    y1: 22.2534,
    x2: 18.2864,
    y2: 47.4068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#E9E9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAFA4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/rank-2.a6247594fcc4ae090a251c5601ea73a7.svg";
export { ForwardRef as ReactComponent };